import React from 'react'
import styled, { css } from 'styled-components'
import { Block, Button, H5, P } from '@mote/ui'
import { CloseIcon } from '@mote/assets/icons'

export const LinkCard = ({ data, disabled, isDismissable, ...rest }) => {
  return (
    <Root layout='vertical' gap={32} disabled={disabled} {...rest}>
      {!disabled && isDismissable && (
        <CloseButton
          className='close-button'
          text={null}
          icon={<CloseIcon color='#25252D' />}
          onClick={null}
        />
      )}
      <DetailsContainer layout='vertical' gap={16} disabled={disabled}>
        <IconContainer className='icon-container'>{data.icon}</IconContainer>
        <Block layout='vertical' gap={8}>
          <H5 fontSize={15} fontWeight={500} lineHeight='100%' color='#25252D'>
            {data.title}
          </H5>
          {data.subtitle && (
            <P fontSize={15} fontWeight={400} lineHeight='100%' color='#6C6C84'>
              {data.subtitle}
            </P>
          )}
        </Block>
      </DetailsContainer>
      <StyledButton text={data.cta.text} onClick={data.cta.action} />
    </Root>
  )
}

const Root = styled(Block)`
  position: relative;
  min-height: 100px;
  padding: 24px;
  border-radius: 8px;
  transition: all 150ms ease-in;
  -webkit-tap-highlight-color: transparent;

  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;

          button {
            pointer-events: none;
            color: rgba(37, 37, 45, 0.3);
            background: #ececf3;
          }
        `
      : css`
          cursor: pointer;
        `}

  &:hover {
    background: #f6f6f9;

    .icon-container {
      background: #ececf3;
    }

    .close-button {
      opacity: 1;
      visibility: visible;

      @media (max-width: 639px) {
        background: #f6f6f9;

        &:hover,
        &:active,
        &:focus {
          background: #ececf3;
        }
      }
    }
  }

  @media (max-width: 639px) {
    padding: 16px;
  }
`

const DetailsContainer = styled(Block)`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: opacity 150ms ease-in;
`

const IconContainer = styled(Block)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  width: 88px;
  min-height: 56px;
  background: #f6f6f9;
  border-radius: 4px;
  transition: all 150ms ease-in;
`

const StyledButton = styled(Button)`
  width: max-content;

  @media (max-width: 639px) {
    width: 100%;
  }
`

const CloseButton = styled(Button)`
  position: absolute;
  right: 12px;
  top: 12px;
  width: 40px;
  height: 40px;
  padding: 0;
  opacity: 0;
  visibility: hidden;
  background: #f6f6f9;
  transition: all 150ms ease-in;

  &:hover,
  &:active,
  &:focus {
    background: #ececf3;
  }

  @media (max-width: 639px) {
    opacity: 1;
    visibility: visible;
    background: #ffffff;
  }
`
